export const MIGRATION_STATUS = {
  MIGRATION_STATUS_PENDING: "PENDING",
  MIGRATION_STATUS_IN_PROGRESS: "IN_PROGRESS",
  MIGRATION_STATUS_REJECTED: "REJECTED",
  MIGRATION_STATUS_COMPLETED: "COMPLETED",
};
